import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

import { AccordionSize } from '@design-system/components/templates/accordion/entities/accordion.types';

@Component({
  selector: 'app-box-filter',
  templateUrl: './box-filter.component.html',
  styleUrls: ['./box-filter.component.sass'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BoxFilterComponent {

  @Input() label: string;
  @Input() show = true;
  @Input() index = -1;
  @Input() individualFilter: boolean;
  
  @Output() toggleShow: EventEmitter<boolean> = new EventEmitter();

  public readonly accordionSize = AccordionSize.SM;

  constructor() { }

  get showDivider(): boolean {
    return !this.individualFilter || (this.index !== 0 && this.index !== -1);
  }

  get showAccordion(): boolean {
    return !this.individualFilter || this.index !== -1;
  }

  public toggle(value: boolean): void {
    this.show = value;
    this.toggleShow.emit(this.show);
  }

}
